module.exports = __webpack_public_path__ + "static/img/about-1-Overview-img-1.e2af9e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-1-Overview-img-1.jpg
// module id = Fc85
// module chunks = 0